module.exports = "<div class=\"modal-wrapper\" ng-show='show'>\n\t<div class=\"modal-overlay\" ng-click='hideModal()'></div>\n\t<div class=\"modal-dialog\">\n\t\t<div class=\"modal-content\" ng-class=\"{'modal-default': !overrideDefaultContainer}\">\n            <a href=\"#\" ng-if=\"showCloseButton\" ng-click=\"hideModal($event)\" class=\"close\">&nbsp;</a>\n            <div ng-transclude>\n            </div>\n\t\t</div>\n\t</div>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-ui-components/src/modal/template.html
 ** module id = 366
 ** module chunks = 1
 **/